import { render } from "./profitDrugSale.vue?vue&type=template&id=2bf49697&scoped=true"
import script from "./profitDrugSale.vue?vue&type=script&lang=js"
export * from "./profitDrugSale.vue?vue&type=script&lang=js"

import "./profitDrugSale.vue?vue&type=style&index=0&id=2bf49697&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bf49697"

export default script